import React from 'react';
import TransactionPropertiesTab from './TransactionPropertiesTab';

const TransactionDetailView = ({ transaction }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <TransactionPropertiesTab transaction={transaction} />
    </div>
  );
};

export default TransactionDetailView;

